import { IPrice } from "../services/order-service";

export function formatPrice(price: IPrice, supClass?: string) {
	let formattedPrice = "";

	const replaceDecimalSeparatorInPrice = (amount: number, decimalSeparator: string) => {
		return amount.toFixed(2).replace(".", decimalSeparator);
	};

	if (window.context.removeCurrencySymbolFormUpperFunnelPages === "true") {
		formattedPrice += replaceDecimalSeparatorInPrice(price.Amount, price.Currency.DecimalSeparator);
		const splitItems = formattedPrice.split(price.Currency.DecimalSeparator);
		formattedPrice = splitItems[0] + price.Currency.DecimalSeparator;
		if (supClass) {
			formattedPrice += '<sup class="' + supClass + '">' + splitItems[1] + "</sup>";
		} else {
			formattedPrice += splitItems[1];
		}
	} else {
		if (price.Currency.DisplayLeftToPrice)
			formattedPrice +=
				price.Currency.CurrencySymbol +
				" " +
				replaceDecimalSeparatorInPrice(price.Amount, price.Currency.DecimalSeparator);
		else
			formattedPrice +=
				replaceDecimalSeparatorInPrice(price.Amount, price.Currency.DecimalSeparator) +
				" " +
				price.Currency.CurrencySymbol;
	}

	return formattedPrice;
}

export function formatItemTotal(
	itemTotal: string,
	currencySymbol: string,
	decimalSeparator: string,
	supClass?: string,
) {
	if (window.context.removeCurrencySymbolFormUpperFunnelPages === "true" && itemTotal.includes(currencySymbol)) {
		const split = itemTotal.split(decimalSeparator);
		let formattedTotal = split[0] + decimalSeparator;
		if (supClass) {
			formattedTotal += '<sup class="' + supClass + '">' + split[1] + "</sup>";
		} else {
			formattedTotal += split[1];
		}

		return formattedTotal.replace(currencySymbol, "").replace("  ", " ");
	}
	return itemTotal;
}

export function formatCalculationDescription(
	calculatedPriceDescription: string,
	currencySymbol: string,
	decimalSeparator: string,
	supClass?: string,
) {
	if (
		window.context.removeCurrencySymbolFormUpperFunnelPages === "true" &&
		calculatedPriceDescription.includes(currencySymbol)
	) {
		const split = calculatedPriceDescription.split(decimalSeparator);
		let formattedPriceDescription = split[0] + decimalSeparator;
		if (supClass) {
			formattedPriceDescription += '<sup class="' + supClass + '">' + split[1] + "</sup>";
		} else {
			formattedPriceDescription += split[1];
		}

		return formattedPriceDescription.replace(currencySymbol, "").replace("  ", " ");
	}
	return calculatedPriceDescription;
}
